import {getFlattenAttrs} from "./attributes";
import config from "../config";

const analytics = {

  fireGoogleAnalyticsEvent: function (...rest) {

    const args = rest;

    if (process.env.NODE_ENV === 'production') {

      const {ga} = window;

      if (ga && typeof ga === 'function') {

        if (ga.getAll !== undefined && ga.getAll()[0].get('name')) {
          analytics._fireGASendEvent(args);
        } else {
          ga(function () {
            setTimeout(function () {
              analytics._fireGASendEvent(args);
            }, 500);
          });
        }

      } else if (this.isLoggingEnabled()) {
        console.log('Real even is not triggered. Google Analytics library is missing.');
      }

    }

    if (this.isLoggingEnabled()) {
      console.log('Google Analytics Event', {
        eventCategory: args[0],
        eventAction: args[1],
        eventLabel: args[2],
        eventValue: args[3]
      });
    }

  },

  _fireGASendEvent: function (args) {

    const {ga} = window;

    if (ga.getAll === undefined) {
      console.log('Even is not triggered. Analytic library error.');
      return;
    }

    var trackerName = ga.getAll()[0].get('name');
    ga(trackerName + '.send', 'event', ...args);
  },

  fireFacebookEvent: function (...rest) {

    const args = rest;

    if (process.env.NODE_ENV === 'production') {

      const {fbq} = window;

      if (fbq && typeof fbq === 'function') {
        fbq('trackCustom', ...args);
      } else if (this.isLoggingEnabled()) {
        console.log('Real even is not triggered. Facebook analytic library is missing.');
      }

    }

    if (this.isLoggingEnabled()) {
      console.log('Facebook analytic Event', {
        event: args[0],
      });
    }

  },

  isLoggingEnabled: function () {
    return config.logAnalytics || process.env.NODE_ENV === 'development';
  },

  onInit: function () {
    this.fireGoogleAnalyticsEvent('Configurator opened');
  },

  onChooseOption: function (optionName) {
    this.fireGoogleAnalyticsEvent('Option Selected', optionName);
  },

  onStepCompeted: function (stepName, selectedOptionName) {
    this.fireGoogleAnalyticsEvent(`Step ${stepName} completed`, selectedOptionName);
  },

  onGoBack: function (currentStepName) {
    this.fireGoogleAnalyticsEvent('Step back', currentStepName);
  },

  onSummeryStep: function () {
    this.fireGoogleAnalyticsEvent('Summary opened');
    this.fireFacebookEvent('KonfiguratorSummaryErreicht');
  },

  onAddToCart: function () {
    this.fireGoogleAnalyticsEvent('Added to cart');
    this.fireFacebookEvent('KonfiguratorAddToCart');
  },

  onConfigurationEmail: function () {
    this.fireGoogleAnalyticsEvent('Configuration sent by email');
    this.fireFacebookEvent('KonfigurationPerMailVerschickt');
  },

  onWhatsAppShare: function () {
    this.fireGoogleAnalyticsEvent('Configuration shared on WhatsApp');
  },

  onContactModalOpened: function () {
    this.fireFacebookEvent('KonfiguratorKontaktPopupGeoeffnet');
  },

  onContactModalSubmitted: function () {
    this.fireFacebookEvent('KonfiguratorEmailAnSupportVerschickt');
  },

  onHistoryChange: function (currentPath, prevPath, type, attrs, params) {

    if (currentPath === '/summary') {
      this.onSummeryStep();
    }

    if (type === 'PUSH') {

      attrs = getFlattenAttrs(attrs);

      let links = attrs.map(attr => `/${config.attrBase}/${attr.slug}`);
      links.push('/summary');

      const currentIndex = links.findIndex(link => link === currentPath),
        prevIndex = links.findIndex(link => link === prevPath);

      if (currentIndex > prevIndex) {
        if (prevIndex !== -1) {
          this.onStepCompeted(attrs[prevIndex].name, params[attrs[prevIndex].slug].value);
        }
      } else if (prevPath === '/summary' || prevIndex !== -1) {
        this.onGoBack(prevPath === '/summary' ? 'Summary' : attrs[prevIndex].name);
      }

    }

  }

};

export default analytics;
